// extracted by mini-css-extract-plugin
export const firstText = "lastText-module--firstText--oV-ur";
export const secondText = "lastText-module--secondText--3q4a2";